export default __webpack_public_path__ + "static/media/ia.17de3486.svg";